// extracted by mini-css-extract-plugin
module.exports = {"albumRow":"SelectAlbumRow-albumRow-3z8ZX"};